import {timeFrom, timeTo} from "../../utils/timeInterval";
import {
    SET_PRICE_FROM_INIT,
    SET_PRICE_TO_INIT,
    SET_CUSTOM_FIELDS,
    SET_SORT,
    SET_SORT2,
    SET_SORT3,
    SET_GROUP,
    SET_TIME_FROM,
    SET_TIME_TO,
    SET_PRICE_FROM,
    SET_PRICE_TO,
    SET_SHOW_CANCELED_ORDERS,
    SET_SHOW_BRUSH_FILTER,
} from '../types';
import React from "react";

// Тайпы интежеров
import {SET_TXCNT_FROM} from '../types';
import {SET_TXCNT_TO} from '../types';
import {SET_ITER_BUY_FROM} from '../types';
import {SET_ITER_BUY_TO} from '../types';
import {SET_ITER_SELL_FROM} from '../types';
import {SET_ITER_SELL_TO} from '../types';
import {SET_TARG_IDX_FROM} from '../types';
import {SET_TARG_IDX_TO} from '../types';
import {SET_ORDER_ID_FROM} from '../types';
import {SET_ORDER_ID_TO} from '../types';
import {SET_FILTER_ORDER_ID_PAIRED_FROM} from '../types';
import {SET_FILTER_ORDER_ID_PAIRED_TO} from '../types';


// Тайпы флотов
import {SET_AMOUNT_FOR_OPER_FROM} from '../types';
import {SET_AMOUNT_FOR_OPER_TO} from '../types';
import {SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM} from '../types';
import {SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO} from '../types';
import {SET_ORDER_PRICE_FROM} from '../types';
import {SET_ORDER_PRICE_TO} from '../types';
import {SET_ORDER_ORIG_AMOUNT_FROM} from '../types';
import {SET_ORDER_ORIG_AMOUNT_TO} from '../types';
import {SET_ORDER_AMOUNT_FROM} from '../types';
import {SET_ORDER_AMOUNT_TO} from '../types';
import {SET_ORDER_EXEX_FROM} from '../types';
import {SET_ORDER_EXEX_TO} from '../types';
import {SET_FEE_RESULT_FROM} from '../types';
import {SET_FEE_RESULT_TO} from '../types';
import {SET_ORDER_REMAINS_FROM} from '../types';
import {SET_ORDER_REMAINS_TO} from '../types';

// Тайпы селектов
import {SET_FILTER_SIDE} from '../types';
import {SET_FILTER_STATUS} from '../types';
import {SET_FILTER_TYPE} from '../types';
import {SET_FILTER_ORDER_ALG} from '../types';
import {SET_FILTER_IS_ROBOT_ORDER} from '../types';
import {SET_FILTER_CYCLE_END} from '../types';
import {SET_FILTER_CYCLE_STAGE} from '../types';
import {SET_FILTER_BASE_CURR} from '../types';

// Тайпы дат
import {SET_FILTER_SDTIME_FROM} from '../types';
import {SET_FILTER_SDTIME_TO} from '../types';
import {SET_FILTER_FDTIME_FROM} from '../types';
import {SET_FILTER_FDTIME_TO} from '../types';


import {customFieldsList} from '../../config';

const initialState = {
    timeFrom: timeFrom,
    timeTo: timeTo,
    priceFrom: '',
    priceTo: '',
    showCanceledOrders: false,
    showBrushFilter: false,
    priceFromInit: 0,
    priceToInit: 0,


    // Фильтры интежеры
    filtertxCNTFrom: '',
    filtertxCNTTo: '',
    filterIterBuyFrom: '',
    filterIterBuyTo: '',
    filterIterSellFrom: '',
    filterIterSellTo: '',
    filterTargIdxFrom: '',
    filterTargIdxTo: '',
    filterorderIdFrom: '',
    filterorderIdTo: '',
    filterOrderIdPairedFrom: '', //integer
    filterOrderIdPairedTo: '', //integer

    // Фильтры флоты
    filteramountForOperFrom: '',
    filteramountForOperTo: '',
    filterorderAmountForOperExecFrom: '',
    filterorderAmountForOperExecTo: '',
    filterorderPriceFrom: '',
    filterorderPriceTo: '',
    filterorderOrigAmountFrom: '',
    filterorderOrigAmountTo: '',
    filterorderAmountFrom: '',
    filterorderAmountTo: '',
    filterorderExecFrom: '',
    filterorderExecTo: '',
    filterfeeResultFrom: '',
    filterfeeResultTo: '',
    filterorderRemainsFrom: '',
    filterorderRemainsTo: '',

    // Селект фильтры
    filterSide: '',
    filterStatus: '',
    filterType: '',
    filterOrderAlg: '',
    filterIsRobotOrder: '', //select
    filterCycleEnd: '', //select
    filterCycleStage: '', //select
    filterBaseCurr: '', //select

    // Дэйт фильтры
    filterSdTimeFrom: '',
    filterSdTimeTo: '',
    filterFdTimeFrom: '',
    filterFdTimeTo: '',

    sort: {
        key: false,
        direction: false,
    },
    sort2: {
        key: false,
        direction: false,
    },
    sort3: {
        key: false,
        direction: false,
    },
    group: {
        key: false,
    },
    customFields: customFieldsList,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_PRICE_FROM_INIT:
            return {
                ...state,
                priceFromInit: action.payload,
            };
        case SET_PRICE_TO_INIT:
            return {
                ...state,
                priceToInit: action.payload,
            };


        case SET_SHOW_BRUSH_FILTER:
            return {
                ...state,
                showBrushFilter: action.payload,
            };
        case SET_SHOW_CANCELED_ORDERS:
            return {
                ...state,
                showCanceledOrders: action.payload,
            };

        case SET_SORT:
            return {
                ...state,
                sort: action.payload,
            };

        case SET_SORT2:
            return {
                ...state,
                sort2: action.payload,
            };

        case SET_SORT3:
            return {
                ...state,
                sort3: action.payload,
            };

        case SET_GROUP:
            return {
                ...state,
                group: action.payload,
            };

        case SET_TIME_FROM:
            return {
                ...state,
                timeFrom: action.payload,
            };
        case SET_TIME_TO:
            return {
                ...state,
                timeTo: action.payload,
            };
        case SET_PRICE_FROM:
            return {
                ...state,
                priceFrom: action.payload,
            };
        case SET_PRICE_TO:
            return {
                ...state,
                priceTo: action.payload,
            };

        case SET_CUSTOM_FIELDS:
            return {
                ...state,
                customFields: action.payload,
            };


        // Кейсы фильтров-интежеров
        case SET_TXCNT_FROM:
            return {...state, filtertxCNTFrom: action.payload,};
        case SET_TXCNT_TO:
            return {...state, filtertxCNTTo: action.payload,};
        case SET_ITER_BUY_FROM:
            return {...state, filterIterBuyFrom: action.payload,};
        case SET_ITER_BUY_TO:
            return {...state, filterIterBuyTo: action.payload,};
        case SET_ITER_SELL_FROM:
            return {...state, filterIterSellFrom: action.payload,};
        case SET_ITER_SELL_TO:
            return {...state, filterIterSellTo: action.payload,};
        case SET_TARG_IDX_FROM:
            return {...state, filterTargIdxFrom: action.payload,};
        case SET_TARG_IDX_TO:
            return {...state, filterTargIdxTo: action.payload,};
        case SET_ORDER_ID_FROM:
            return {...state, filterorderIdFrom: action.payload,};
        case SET_ORDER_ID_TO:
            return {...state, filterorderIdTo: action.payload,};
        case SET_FILTER_ORDER_ID_PAIRED_FROM:
            return {...state, filterOrderIdPairedFrom: action.payload,};
        case SET_FILTER_ORDER_ID_PAIRED_TO:
            return {...state, filterOrderIdPairedTo: action.payload,};

        // Кейсы фильтров-флотов
        case SET_AMOUNT_FOR_OPER_FROM:
            return {...state, filteramountForOperFrom: action.payload,};
        case SET_AMOUNT_FOR_OPER_TO:
            return {...state, filteramountForOperTo: action.payload,};
        case SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM:
            return {...state, filterorderAmountForOperExecFrom: action.payload,};
        case SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO:
            return {...state, filterorderAmountForOperExecTo: action.payload,};
        case SET_ORDER_PRICE_FROM:
            return {...state, filterorderPriceFrom: action.payload,};
        case SET_ORDER_PRICE_TO:
            return {...state, filterorderPriceTo: action.payload,};
        case SET_ORDER_ORIG_AMOUNT_FROM:
            return {...state, filterorderOrigAmountFrom: action.payload,};
        case SET_ORDER_ORIG_AMOUNT_TO:
            return {...state, filterorderOrigAmountTo: action.payload,};
        case SET_ORDER_AMOUNT_FROM:
            return {...state, filterorderAmountFrom: action.payload,};
        case SET_ORDER_AMOUNT_TO:
            return {...state, filterorderAmountTo: action.payload,};
        case SET_ORDER_EXEX_FROM:
            return {...state, filterorderExecFrom: action.payload,};
        case SET_ORDER_EXEX_TO:
            return {...state, filterorderExecTo: action.payload,};
        case SET_FEE_RESULT_FROM:
            return {...state, filterfeeResultFrom: action.payload,};
        case SET_FEE_RESULT_TO:
            return {...state, filterfeeResultTo: action.payload,};
        case SET_ORDER_REMAINS_FROM:
            return {...state, filterorderRemainsFrom: action.payload,};
        case SET_ORDER_REMAINS_TO:
            return {...state, filterorderRemainsTo: action.payload,};


        // Кейсы фильтров-селектов
        case SET_FILTER_SIDE:
            return {...state, filterSide: action.payload,};
        case SET_FILTER_STATUS:
            return {...state, filterStatus: action.payload,};
        case SET_FILTER_TYPE:
            return {...state, filterType: action.payload,};
        case SET_FILTER_ORDER_ALG:
            return {...state, filterOrderAlg: action.payload,};
        case SET_FILTER_IS_ROBOT_ORDER:
            return {...state, filterIsRobotOrder: action.payload,};
        case SET_FILTER_CYCLE_END:
            return {...state, filterCycleEnd: action.payload,};
        case SET_FILTER_CYCLE_STAGE:
            return {...state, filterCycleStage: action.payload,};
        case SET_FILTER_BASE_CURR:
            return {...state, filterBaseCurr: action.payload,};

        // Кейсы фильтров-дат
        case SET_FILTER_SDTIME_FROM:
            return {...state, filterSdTimeFrom: action.payload,};
        case SET_FILTER_SDTIME_TO:
            return {...state, filterSdTimeTo: action.payload,};
        case SET_FILTER_FDTIME_FROM:
            return {...state, filterFdTimeFrom: action.payload,};
        case SET_FILTER_FDTIME_TO:
            return {...state, filterFdTimeTo: action.payload,};

        default:
            return state;
    }
}
